import { createFileRoute } from '@tanstack/react-router';
import { CategoriasPage } from '@/components/categorias';

export const Route = createFileRoute('/_app/cadastros/categorias')({
  component: CategoriasPage,
});
